<template>
    <!-- <div v-if="image" class="stitch-preview-container" :class="[position, { clickable: !disabled }]"
        :style="containerStyle" @click="handleClick"> -->
    <div v-if="image" class="stitch-preview-container max-h-[400px]"
        :class="[position, { clickable: !disabled }, position === 'prev' ? 'prev' : '']" :style="containerStyle"
        @click="handleClick">
        <!-- 显示编辑后的图片（拼接效果） -->
        <img :src="image.displayUrl" :alt="position === 'prev' ? '上一张' : '下一张'" :style="imageStyle"
            class="stitch-image object-cover object-bottom" crossorigin="anonymous" @load="handleImageLoad"
            @error="handleImageError" />

        <!-- 悬停提示 -->
        <div v-if="!disabled" class="hover-hint">
            <span v-if="position === 'prev'">
                <UpOutlined /> 点击编辑上一张
            </span>
            <span v-else>
                <DownOutlined /> 点击编辑下一张
            </span>
        </div>
    </div>

    <!-- 无图片时的占位 -->
    <div v-else class="stitch-preview-container empty flex flex-column flex-center" :class="position">
        <div class="empty-hint">
            {{ position === 'prev' ? '已是第一张' : '已是最后一张' }}
        </div>
    </div>
</template>

<script setup>
import { ref, computed, watch } from 'vue';
import { useStore } from 'vuex';
import { UpOutlined, DownOutlined } from '@ant-design/icons-vue';
import { getCORSImageUrl } from '@/utils';

const props = defineProps({
    position: {
        type: String,
        required: true,
        validator: (value) => ['prev', 'next'].includes(value),
    },
    image: {
        type: Object,
        default: null,
    },
    scale: {
        type: Number,
        default: 1,
    },
    currentEditingWidth: {
        type: Number,
        default: 0,
    },
});

const emit = defineEmits(['click']);

const store = useStore();
const appState = computed(() => store.state.app);

// 图片原始尺寸
const imageWidth = ref(0);
const imageHeight = ref(0);

// 禁用条件
const disabled = computed(() => {
    return (
        appState.value.editorLoading ||
        appState.value.currentMenuAction !== ''
    );
});

const containerStyle = computed(() => {
    if (!imageHeight.value) {
        return {
            minHeight: '100px',
        };
    }

    // const scaledHeight = Math.round(imageHeight.value * props.scale);
    // const imgScale = Math.round(imageHeight.value / imageWidth.value)
    const imgScale = imageHeight.value / imageWidth.value
    const imgHeight = Math.round(props.currentEditingWidth * imgScale)

    return {
        height: `${imgHeight}px`,
    };
});

const imageStyle = computed(() => {
    if (!imageWidth.value || !imageHeight.value) {
        return {
            display: 'block',
            width: '100%',
            height: 'auto',
        };
    }

    console.log({ 'currentEditingWidth----danqian': props.currentEditingWidth })

    const scaledWidth = Math.round(imageWidth.value * props.scale);
    const scaledHeight = Math.round(imageHeight.value * props.scale);

    // const imgScale = Math.round(imageHeight.value / imageWidth.value)
    const imgScale = imageHeight.value / imageWidth.value
    const imgHeight = Math.round(props.currentEditingWidth * imgScale)
    console.log({ originScale: imageHeight.value / imageWidth.value, roundeScale: imgScale, imageWidth, imageHeight })

    return {
        display: 'block',
        // width: `${scaledWidth}px`,
        width: `${props.currentEditingWidth}px`,
        // height: `${scaledHeight}px`,
        // height: '300px',
        height: `${imgHeight}px`,
        margin: '0 auto',
    };
});

const handleImageLoad = (e) => {
    imageWidth.value = e.target.naturalWidth;
    imageHeight.value = e.target.naturalHeight;

    console.log(`[ImageStitchPreview ${props.position}] 图片加载:`, {
        naturalWidth: e.target.naturalWidth,
        naturalHeight: e.target.naturalHeight,
        scale: props.scale,
        scaledWidth: Math.round(e.target.naturalWidth * props.scale),
        scaledHeight: Math.round(e.target.naturalHeight * props.scale),
    });
};

const handleClick = () => {
    if (disabled.value || !props.image) return;
    emit('click');
};

watch(() => props.image?.displayUrl, (newUrl) => {
    // 图片 URL 变化时，重置尺寸，等待新图片加载
    imageWidth.value = 0;
    imageHeight.value = 0;
    console.log(`[ImageStitchPreview ${props.position}] 图片变化:`, {
        hasImage: !!props.image,
        displayUrl: newUrl?.substring(0, 80),
    });
}, { immediate: true });

const handleImageError = (e) => {
    console.error(`[ImageStitchPreview ${props.position}] 图片加载失败:`, {
        displayUrl: props.image?.displayUrl,
        error: e,
    });
};
</script>

<style lang="less" scoped>
.stitch-preview-container {
    flex-shrink: 0;
    overflow-x: auto;
    overflow-y: hidden;
    display: flex;
    align-items: flex-start;
    // align-items: flex-end;
    justify-content: center;
    position: relative;
    cursor: pointer;
    background: #eef2f7;
    margin: 0 !important;
    padding: 0 !important;
    border: none !important;
    line-height: 0;

    &.prev {
        align-items: flex-end;
    }

    &.clickable {
        &:hover {
            &::after {
                content: '';
                position: absolute;
                inset: 0;
                background: rgba(43, 140, 255, 0.1);
                pointer-events: none;
            }

            .stitch-image {
                opacity: 1;
            }

            .hover-hint {
                opacity: 1;
            }
        }
    }

    &.empty {
        height: 100px;
        background: #f5f5f5;
        cursor: not-allowed;
    }
}

.stitch-image {
    opacity: 0.85;
    transition: opacity 0.3s;
    display: block;
    margin: 0;
    padding: 0;
    border: none;
}

.hover-hint {
    position: absolute;
    bottom: 16px;
    left: 50%;
    transform: translateX(-50%);
    padding: 6px 12px;
    background: rgba(0, 0, 0, 0.7);
    color: white;
    border-radius: 4px;
    font-size: 12px;
    white-space: nowrap;
    pointer-events: none;
    opacity: 0;
    transition: opacity 0.3s;

    span {
        display: flex;
        align-items: center;
        gap: 4px;
    }
}

.empty-hint {
    font-size: 14px;
    color: #999;
    height: 100px;
    line-height: 100px;
    text-align: center;
}
</style>
